import { useTranslation } from 'react-i18next';

import { OppvarmingFormData } from '../../../types';

export const useBioenergiValidation = () => {
  const { t } = useTranslation();
  const validateBioenergiSelection = (_: boolean, formValues: OppvarmingFormData) => {
    const anySelected =
      formValues.bioenergi?.value?.kamin?.selected ||
      formValues.bioenergi?.value?.kaminMedVannbarenVarme?.selected ||
      formValues.bioenergi?.value?.kjel?.selected;

    if (!anySelected) {
      return t('form.oppvarming.bioenergi.error');
    }
    return true;
  };

  return { validateBioenergiSelection };
};
